webpackJsonp([76],{

/***/ 1277:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(1278);


/***/ }),

/***/ 1278:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _datetime = __webpack_require__(177);

var _datetime2 = _interopRequireDefault(_datetime);

var _es = __webpack_require__(790);

var _es2 = _interopRequireDefault(_es);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_datetime2.default.lang('es', _es2.default);

/***/ })

},[1277]);


// WEBPACK FOOTER //
// app/datetime.es-5cdc054f398b281d02b9.js